import axios from "axios";
import { TeamGoalAnalysisApiModel, TeamGoalsApiModel } from "../../api-models";

export type TeamGoalVariable = {
  name: string;
  id: string;
  analysis: TeamGoalAnalysisApiModel[];
};

async function getTeamGoals(teamId: string): Promise<TeamGoalsApiModel> {
  const response = await axios.get<TeamGoalsApiModel>(`/api/teamgoals/${teamId}`);
  return response.data;
}

export default async function getTeamGoalVariables(
  teamId: string,
): Promise<TeamGoalVariable[] | string> {
  const teamGoalsModel = await getTeamGoals(teamId);

  if (!teamGoalsModel.teamGoals.length) return "No team goals submitted";

  return teamGoalsModel.teamGoals
    .sort((a, b) => (new Date(a.createdDate) as any) - (new Date(b.createdDate) as any))
    .map((goal) => {
      return {
        name: goal.goalName,
        id: goal.id,
        analysis: goal.teamGoalAnalyses,
      };
    });
}
